<div class="dialog-container">
  <h2 mat-dialog-title>
    {{ data.title }}
    <button type="button" mat-icon-button mat-dialog-close class="close-button" [aria-label]="'Close' | translate:locale.language">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <table mat-table [dataSource]="data.datasource">
      <ng-container *ngFor="let column of data.columns" [matColumnDef]="column.key" [sticky]="true">
        <th mat-header-cell *matHeaderCellDef [attr.data-test]="'column-header-' + column.key" [innerText]="column.label"></th>
        <td mat-cell *matCellDef="let element; let i = dataIndex" [attr.data-test]="'column-' + column.key + '-' + i">
          {{ element[column.key] }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
  </mat-dialog-content>

  <mat-dialog-actions>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </mat-dialog-actions>
</div>
